"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DialogWidth;
(function (DialogWidth) {
    DialogWidth["NONE"] = "";
    DialogWidth["SMALL"] = "dialog-width-small";
    DialogWidth["MEDIUM"] = "dialog-width-medium";
    DialogWidth["LARGE"] = "dialog-width-large";
    DialogWidth["FULL"] = "dialog-width-full";
    DialogWidth["FIT_CONTENT"] = "dialog-width-fit-content";
    DialogWidth["AUTO"] = "dialog-width-auto";
})(DialogWidth || (DialogWidth = {}));
exports.default = DialogWidth;
//# sourceMappingURL=DialogWidth.js.map